"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Webform = exports.EventEmitter = exports.Licenses = exports.AriForm = exports.Form = exports.Utils = exports.Templates = exports.Widgets = exports.Providers = exports.Displays = exports.Components = exports.AriFormCore = exports.useModule = exports.registerModule = void 0;
const lodash_1 = __importDefault(require("lodash"));
const AriForm_1 = require("./AriForm");
Object.defineProperty(exports, "AriForm", { enumerable: true, get: function () { return AriForm_1.AriForm; } });
const components_1 = __importDefault(require("./components"));
const Components_1 = __importDefault(require("./components/Components"));
exports.Components = Components_1.default;
const Displays_1 = __importDefault(require("./displays/Displays"));
exports.Displays = Displays_1.default;
const Templates_1 = __importDefault(require("./templates/Templates"));
exports.Templates = Templates_1.default;
const providers_1 = __importDefault(require("./providers"));
exports.Providers = providers_1.default;
const widgets_1 = __importDefault(require("./widgets"));
exports.Widgets = widgets_1.default;
const Form_1 = __importDefault(require("./Form"));
exports.Form = Form_1.default;
const utils_1 = __importDefault(require("./utils"));
exports.Utils = utils_1.default;
const Evaluator_1 = require("./utils/Evaluator");
const licenses_1 = __importDefault(require("./licenses"));
exports.Licenses = licenses_1.default;
const EventEmitter_1 = __importDefault(require("./EventEmitter"));
exports.EventEmitter = EventEmitter_1.default;
const Webform_1 = __importDefault(require("./Webform"));
exports.Webform = Webform_1.default;
AriForm_1.AriForm.loadModules = (path = `${AriForm_1.AriForm.getApiUrl()}/externalModules.js`, name = 'externalModules') => {
    AriForm_1.AriForm.requireLibrary(name, name, path, true)
        .then((modules) => {
        AriForm_1.AriForm.use(modules);
    });
};
// This is needed to maintain correct imports using the "dist" file.
AriForm_1.AriForm.isRenderer = true;
AriForm_1.AriForm.Components = Components_1.default;
AriForm_1.AriForm.Templates = Templates_1.default;
AriForm_1.AriForm.Utils = utils_1.default;
AriForm_1.AriForm.Form = Form_1.default;
AriForm_1.AriForm.Displays = Displays_1.default;
AriForm_1.AriForm.Providers = providers_1.default;
AriForm_1.AriForm.Widgets = widgets_1.default;
AriForm_1.AriForm.Evaluator = Evaluator_1.Evaluator;
AriForm_1.AriForm.AllComponents = components_1.default;
AriForm_1.AriForm.Licenses = licenses_1.default;
// This is strange, but is needed for "premium" components to import correctly.
AriForm_1.AriForm.AriForm = AriForm_1.AriForm;
AriForm_1.AriForm.Components.setComponents(components_1.default);
/**
 * Register a module
 * @param {any} mod - The module object to register. This can also be a function which accepts AriForm as an argument.
 * @param {Function|null} [defaultFn] - The default function to call if the module does not have a known key.
 * @param {any} options - Options for the module.
 * @returns {void}
 */
function registerModule(mod, defaultFn = null, options = {}) {
    if (typeof mod === 'function') {
        return registerModule(mod(AriForm_1.AriForm), defaultFn, options);
    }
    if (typeof mod !== 'object') {
        return;
    }
    for (const key of Object.keys(mod)) {
        const current = mod.framework || AriForm_1.AriForm.Templates.framework || 'bootstrap';
        switch (key) {
            case 'options':
                AriForm_1.AriForm.options = lodash_1.default.merge(AriForm_1.AriForm.options, mod.options);
                break;
            case 'templates':
                for (const framework of Object.keys(mod.templates)) {
                    AriForm_1.AriForm.Templates.extendTemplate(framework, mod.templates[framework]);
                }
                if (mod.templates[current]) {
                    AriForm_1.AriForm.Templates.current = mod.templates[current];
                }
                break;
            case 'components':
                AriForm_1.AriForm.Components.setComponents(mod.components);
                break;
            case 'framework':
                AriForm_1.AriForm.Templates.framework = mod.framework;
                break;
            case 'fetch':
                for (const name of Object.keys(mod.fetch)) {
                    AriForm_1.AriForm.registerPlugin(mod.fetch[name], name);
                }
                break;
            case 'providers':
                for (const type of Object.keys(mod.providers)) {
                    AriForm_1.AriForm.Providers.addProviders(type, mod.providers[type]);
                }
                break;
            case 'displays':
                AriForm_1.AriForm.Displays.addDisplays(mod.displays);
                break;
            case 'evaluator':
                AriForm_1.AriForm.Evaluator.registerEvaluator(mod.evaluator);
                break;
            case 'library':
                options.license
                    ? AriForm_1.AriForm.Licenses.addLicense(mod.library, options.license)
                    : AriForm_1.AriForm.Licenses.removeLicense(mod.library);
                break;
            default:
                if (defaultFn) {
                    if (!defaultFn(key, mod)) {
                        console.warn('Unknown module option', key);
                    }
                    break;
                }
                console.log('Unknown module option', key);
        }
    }
}
exports.registerModule = registerModule;
/**
 * @param {Function|null} defaultFn - The default function to call if the module does not have a known key.
 * @returns {void}
 */
function useModule(defaultFn = null) {
    return (plugins, options = {}) => {
        plugins = lodash_1.default.isArray(plugins) ? plugins : [plugins];
        plugins.forEach((plugin) => {
            if (Array.isArray(plugin)) {
                plugin.forEach(p => registerModule(p, defaultFn, options));
            }
            else {
                registerModule(plugin, defaultFn, options);
            }
        });
    };
}
exports.useModule = useModule;
/**
 * Allows passing in plugins as an array of plugins or a single plugin.
 *
 * AriForm.plugins(plugin1, options);
 * AriForm.plugins([plugin1, plugin2, etc], options);
 */
AriForm_1.AriForm.use = useModule();
var AriForm_2 = require("./AriForm");
Object.defineProperty(exports, "AriFormCore", { enumerable: true, get: function () { return AriForm_2.AriForm; } });
